// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectionContainer_wrapper__h03Ts"};